import qs from 'qs';

export const urls = {
  learnMore:
    'https://support.atlassian.com/bitbucket-cloud/docs/use-gpg-keys-to-sign-commits/',
  gpgKeyCreation: '/account/settings/gpg-keys',
  api: {
    gpgKeys: (
      selectedUser = '',
      fingerprint = '',
      options?: { [key: string]: any }
    ): string => {
      const url = `/!api/2.0/users/${selectedUser}/gpg-keys/${fingerprint}`;
      if (options) {
        return `${url}${qs.stringify(options, {
          skipNulls: true,
          addQueryPrefix: true,
        })}`;
      }
      return url;
    },
  },
};
